{
  "fr": {
    "client": {
      "actions": {
        "changeBackgroundImage": "Changer l'image de l'écran de connexion",
        "new": "Ajouter Client",
        "setAsPrimary": "Définir comme principal",
        "submit": "Enregistrer",
        "undoChanges": "Annuler"
      },
      "attributes": {
        "address": "Adresse",
        "aftercare_conversation_enabled": "Entretiens de suivi",
        "backgroundImage": "Image de l'écran de connexion",
        "email_address": "Email",
        "email_address_invoicing": "E-mail de facturation",
        "email_address_renewal": "E-mail de rappel de renouvellement de contrat",
        "email_address_reply_to": "Adresse e-mail \"Reply-To\"",
        "email_address_ziggu": "Adresse e-mail \"From\"",
        "iban": "IBAN",
        "language": "Langue",
        "languages": "Langues de l'entreprise",
        "name": "Nom",
        "phone": "Numéro de téléphone",
        "storage_sum": "Utilisation du Stockage",
        "storage_sum_max": "Vous utilisez actuellement {percentage}% de votre stockage total ({gigabytes} GB)",
        "subdomain": "Subdomain",
        "timezone": "Fuseau horaire",
        "vat_number": "Numéro de TVA"
      },
      "client_types": {
        "architects_designers": "Architectes et designers",
        "creative_agencies": "Agences de création",
        "general_specialized_contractors": "Entrepreneurs généraux et spécialisés",
        "makers_manufacturers": "Concepteurs et fabricants",
        "planners_coordinators": "Planificateurs et coordinateurs",
        "property_developers": "Promoteurs immobiliers"
      },
      "integrations": {
        "api_docs_info": "Pour plus d'informations sur notre API, veuillez consulter notre",
        "api_documentation": "documentation API"
      },
      "labels": {
        "activeProjects": "Projets actifs",
        "activeProjectsUsed": "{0} projets actifs, {1} pas encore utilisé",
        "activeUnits": "Unités actives",
        "activeUnitsUsed": "{0} Unités actives, {1} pas encore utilisés",
        "after_care_categories": "Catégories",
        "after_care_statuses": "Statuts",
        "aftercare": "Après-vente",
        "by": "De {client}",
        "categories": "Catégories",
        "category": "Catégorie",
        "chatWithUs": "Chat avec nous",
        "companyProfile": "Profil de l'entreprise",
        "contactIntercom": "Contacter-nous via le chat si vous souhaitez modifier cela.",
        "contactZiggu": "Vous avez une question à poser à Ziggu ? Vous avez un problème ? Un conseil sur un produit ? Discutons-en !",
        "conversations": "Conversations",
        "dashboard": "Tableau de bord",
        "decisions": "Décisions",
        "default_payment_overdue": "Vous avez une facture impayée pour Ziggu. Veuillez le payer immédiatement pour éviter les intérêts. Des questions ? N'hésitez pas à nous contacter.",
        "delete_category": "Supprimer {category} catégorie?",
        "delete_category_expl": "La suppression d'une catégorie de document ne peut pas être annulée. Les documents existants avec cette catégorie seront remplacés par la catégorie Autre",
        "document_categories": "Catégories",
        "documents": "Documents",
        "email_address_invoicing_info": "Nous enverrons de nouvelles factures à cette adresse.",
        "email_address_renewal_info": "Nous vous enverrons des e-mails à l'adresse lorsque la date de renouvellement de votre abonnement approche et nous souhaitons vous en informer avec toutes les informations nécessaires.",
        "email_address_reply_to": "Cette adresse e-mail sera utilisée si quelqu'un répond à un e-mail envoyé via {email_address_ziggu}. Contacter-nous via le chat si vous souhaitez modifier cela.",
        "email_address_ziggu": "Cette adresse e-mail sera utilisée comme adresse d'expédition de tous les e-mails envoyés via la plateforme (e-mails concernant les notifications, les invitations, les réinitialisations de mot de passe, ...)",
        "email_forwarder_must_be_owner": "Seuls les membres de l'équipe avec le rôle 'Propriétaire' peuvent transférer des e-mails.",
        "email_forwarding_activated": "Transfert d'e-mails est active",
        "email_forwarding_activated_project": "Transfert d'e-mails du projet est active",
        "email_forwarding_disclaimer": "Pour éviter les spams, seuls les courriels envoyés à partir d'une adresse liée à un profil de propriétaire/mainteneur existant sont traités.<br>Les courriels provenant d'expéditeurs inconnus seront ignorés.",
        "email_forwarding_is": "Votre adresse de réexpédition est",
        "financials": "Finances",
        "general": "Général",
        "goToSettings": "Paramètres",
        "helpcenter": "Centre d'aide",
        "inbound_email": "E-mail entrant",
        "invoice_overdue": "Vous avez un retard de paiement. Veuillez nous contacter à accounting{'@'}ziggu.io pour plus d'informations.",
        "invoice_overdue_title": "Facture en retard",
        "language": "La langue par défaut pour votre page de connexion, vos clients et les collègues.",
        "languages": "La langue principale est la langue par défaut pour la saisie de contenu et ne peut pas être supprimée. Ajoutez des langues supplémentaires pour prendre en charge le contenu multilingue. Cliquez sur une langue supplémentaire pour la définir comme langue principale.",
        "mobile_app_disabled": "L'application mobile (PWA) n'est pas active",
        "mobile_app_enabled": "Application mobile (PWA) active",
        "mobile_app_info": "Envoyez-nous un message sur Intercom pour plus d'informations !",
        "mustBeJPG": "Doit être une image .jpg",
        "new_categories": "Catégories supplémentaires",
        "new_document_category": "Catégorie",
        "noCategories": "Vous n'avez pas encore de catégories. Créez-en une pour commencer.",
        "other": "Autre",
        "outOfOffice": "Absent du bureau",
        "outOfOfficeMessage": "Message d'absence du bureau (optionnel)",
        "packageUnits": "Souscrit à",
        "primary": "Principale",
        "removed_user": "Utilisateur supprimé",
        "settings": {
          "click_to_copy": "Cliquez pour copier le jeton dans le presse-papiers",
          "copied_to_clipboard": "Jeton copié dans le presse-papiers"
        },
        "snippets": "Extraits",
        "subscription": "Abonnement",
        "subscriptionRenewalDate": "Date de renouvellement",
        "subscriptionUsageUnits": "Utilisation actuelle",
        "tab_aftercare": "Après-vente",
        "tab_company": "Entreprise",
        "tab_information": "Informations",
        "tab_integrations": "Intégrations",
        "tab_settings": "Paramètres",
        "tab_subscription": "Abonnement",
        "tickets": "Conversations",
        "timezone": "Il s'agit du fuseau horaire par défaut de l'entreprise.",
        "translation_not_added_yet": "La traduction n'est pas encore ajoutée",
        "unchangeable_categories": "Catégories par défaut qui ne sont pas modifiables",
        "unchangeable_categories_info": "Ces catégories sont nécessaires au bon fonctionnement du système ou sont utilisées dans des intégrations.",
        "upgradePackageContactUs": "Contactez-nous pour commencer",
        "upgradePackageSubtitleAftercare": "Cette fonctionnalité vous permettra de suivre les clients après la livraison et de les aider à résoudre tout problème avec leur nouvelle maison",
        "upgradePackageSubtitleConversationMentions": "Cette fonctionnalité vous permettra d'écrire des notes privées et de marquer les membres de l'équipe dans une conversation",
        "upgradePackageSubtitleFinancials": "Créer un aperçu financier pour chaque acheteur en un instant",
        "upgradePackageSubtitleMilestones": "Cette fonctionnalité vous permet de communiquer facilement l'avancement de la construction à votre client",
        "upgradePackageSubtitleMultipleCustomerSingleUnit": "Cette fonctionnalité vous permettra d'inviter un deuxième acheteur sur la plateforme Ziggu",
        "upgradePackageTitle": "Il semble que vous n'ayez pas encore cette fonctionnalité",
        "warningooo": "Bannière d'absence du bureau actif",
        "yourEmail": "Votre email",
        "zigguHome": "Accueil Ziggu"
      },
      "project_types": {
        "mup": "MUP",
        "mup_and_sup": "MUP et SUP",
        "sup": "SUPs"
      },
      "toasts": {
        "attachment_category": {
          "create": "Catégorie de document créée",
          "update": "La catégorie de document a été mise à jour"
        }
      },
      "validation": {
        "attachment_category_required": "La catégorie est obligatoire",
        "duplicated_translation": "Traduction dupliquée",
        "mustBeEmailAddress": "Doit être une adresse email",
        "needName": "Champ requis"
      }
    }
  }
}
